import axios from 'axios';
import { getAuthToken } from '../auth/authSession';

const API_BASE =
  process.env.REACT_APP_API_URL ??
  'http://localhost:5000/api';

const reportClient = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json'
  }
});

// ATTACH TOKEN
reportClient.interceptors.request.use(
  config => {
    const token = getAuthToken();

    if (token) {
      config.headers.Authorization =
        `Bearer ${token}`;
    }

    return config;
  }
);

// GET USER REPORT
export const getUsersReport =
  async (filters?: any) => {
    try {

      const { data } =
        await reportClient.get(
          '/admin/reports/users',
          {
            params: filters
          }
        );

      return data;

    } catch (error: any) {
      throw new Error(
        error.response?.data?.message ||
        'Failed to fetch reports'
      );
    }
};

// DOWNLOAD CSV
export const downloadUsersCSV =
  async (filters?: any) => {
    try {

      const response =
        await reportClient.get(
          '/admin/reports/users/export',
          {
            params: filters,
            responseType: 'blob'
          }
        );

      const blob = new Blob(
        [response.data],
        {
          type: 'text/csv'
        }
      );

      const url =
        window.URL.createObjectURL(blob);

      const link =
        document.createElement('a');

      link.href = url;

      // DYNAMIC FILE NAME
      let fileName =
        'users-report.csv';

      if (filters?.type === 'daily') {
        fileName =
          'daily-users-report.csv';
      }

      if (filters?.type === 'monthly') {
        fileName =
          'monthly-users-report.csv';
      }

      link.setAttribute(
        'download',
        fileName
      );

      document.body.appendChild(link);

      link.click();

      link.remove();

    } catch (error: any) {
      throw new Error(
        error.response?.data?.message ||
        'CSV download failed'
      );
    }
};

// GET SHIFT REPORT
export const getShiftsReport =
  async (filters?: any) => {
    try {

      const { data } =
        await reportClient.get(
          '/admin/reports/shifts',
          {
            params: filters
          }
        );

      return data;

    } catch (error: any) {
      throw new Error(
        error.response?.data?.message ||
        'Failed to fetch shift reports'
      );
    }
};

// DOWNLOAD SHIFTS CSV
export const downloadShiftsCSV =
  async (filters?: any) => {
    try {

      const response =
        await reportClient.get(
          '/admin/reports/shifts/export',
          {
            params: filters,
            responseType: 'blob'
          }
        );

      const blob = new Blob(
        [response.data],
        {
          type: 'text/csv'
        }
      );

      const url =
        window.URL.createObjectURL(blob);

      const link =
        document.createElement('a');

      link.href = url;

      link.setAttribute(
        'download',
        'shifts-report.csv'
      );

      document.body.appendChild(link);

      link.click();

      link.remove();

    } catch (error: any) {
      throw new Error(
        error.response?.data?.message ||
        'Shifts CSV download failed'
      );
    }
};

// GET BOOKING REPORT
export const getBookingsReport =
  async (filters?: any) => {
    try {

      const { data } =
        await reportClient.get(
          '/admin/reports/bookings',
          {
            params: filters
          }
        );

      return data;

    } catch (error: any) {
      throw new Error(
        error.response?.data?.message ||
        'Failed to fetch booking reports'
      );
    }
};

// DOWNLOAD BOOKINGS CSV
export const downloadBookingsCSV =
  async (filters?: any) => {
    try {

      const response =
        await reportClient.get(
          '/admin/reports/bookings/export',
          {
            params: filters,
            responseType: 'blob'
          }
        );

      const blob = new Blob(
        [response.data],
        {
          type: 'text/csv'
        }
      );

      const url =
        window.URL.createObjectURL(blob);

      const link =
        document.createElement('a');

      link.href = url;

      link.setAttribute(
        'download',
        'bookings-report.csv'
      );

      document.body.appendChild(link);

      link.click();

      link.remove();

    } catch (error: any) {
      throw new Error(
        error.response?.data?.message ||
        'Bookings CSV download failed'
      );
    }
  };